<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <el-select class="handle-select mr8" v-model="query.hotel_id" clearable filterable placeholder="请选择" @change="getHallList">
                    <el-option v-for="item in hotelList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                </el-select>
                <el-date-picker class="mr8" v-model="query.year" type="year" value-format="yyyy" placeholder="请选择年份" @change="isLeapYear"></el-date-picker>
                <!-- <el-checkbox-group v-model="query.type">
            <el-checkbox label="1" name="type">午宴</el-checkbox>
            <el-checkbox label="2" name="type">午宴</el-checkbox>
        </el-checkbox-group> -->
                <el-button class="btn-search" type="primary" icon="el-icon-search" @click="getSchedule()">搜索</el-button>

                <div class="tag_list"><span class="tag_schedul"></span><span class="tag_font">档期</span></div>
                <div class="tag_list"><span class="tag_order"></span><span class="tag_font">婚宴</span></div>
                <div class="tag_list"><span class="tag_order_bb"></span><span class="tag_font">宝宝</span></div>
                <div class="tag_list"><span class="tag_order_contant"></span><span class="tag_font">会务</span></div>

                <div class="tag_list"><span class="tag_wuyan"></span><span class="tag_font">午宴</span></div>

                <div class="tag_list"><span class="tag_wanyan"></span><span class="tag_font">晚宴</span></div>
            </div>

        </div>
        <div class="schedule-box">
            <template v-for="month in 12">
                <div class="month-box" :key="month">
                    <div class="month-header">
                        <div class="col-day col-title">{{month}}月</div>
                        <template v-for="day1 in 31">
                            <div v-if="smallMonth.includes(month) && day1 > 30" class="col-day" :key="day1"></div>
                            <div v-else-if="month==2 && day1 > Feb" class="col-day" :key="day1"></div>
                            <div v-else class="col-day" :key="day1">{{day1}}</div>
                        </template>
                    </div>
                    <div class="month-body">
                        <div class="row-hall" v-if="!hallList.length">
                            <div class="col-day">暂无数据</div>
                        </div>
                        <template v-for="(hall,index) in hallList">
                            <div class="row-hall" :key="index">
                                <div class="col-day col-title">{{hall.title}}</div>
                                <div class="col-day" :key="day2" v-for="day2 in 31" @dblclick="openDialog(hall.id, query.year, month, day2,'add')">
                                    <div v-if="group[month] && group[month][hall.id] && group[month][hall.id][day2]" @click.stop="openDetailsDialog(hall.id, query.year, month, day2)">
                                        <div class="col_list" v-for="(item,index) in group[month][hall.id][day2]" :key="index">
                                            <div class="col_item tag" :key="item.id" :class="'tag-'+item.news_type"></div>
                                            <div class="col_item" :key="item.id +'a'" v-if="item.banquet_type">
                                                <div class="banquet_type" v-html='dictionary.convertBanquetTypeToStrslice(item.banquet_type).replace("\\", "/").replace("\\", "/")'></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else :key="day2">-</div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </div>
        <add-schedule ref="addSchedule" />
        <details-Schedule ref="detailsSchedule" />
    </div>
</template>

<script>
import addSchedule from './components/add'; //   当前档期查询
import detailsSchedule from './components/details'; //   查看详情
import {
    post
} from '@/api/http.js'

import dictionary from '@/utils/dictionary.js'
export default {
    components: {
        addSchedule,
        detailsSchedule
    },
    beforeCreate() {
        this.dictionary = dictionary;
    },
    data() {
        let hotelList = dictionary.getPicker('hotel');
        return {
            // picker相关
            hotelList: hotelList,
            hallList: [],
            detailType: {
                hallid: '',
                year: '',
                day: '',
                month: ''
            },

            // 查询表单项
            query: {
                hotel_id: '',
                year: '',
                hotel_title: '',
                type: [],
            },
            bigMonth: [1, 3, 5, 7, 8, 10, 12],
            smallMonth: [4, 6, 9, 11],
            group: [],
            Feb: 29,
        }
    },
    created() { },
    methods: {

        // 获取厅列表
        getHallList(hotelId) {
            let _this = this;
            let url = '/api/dictionary.hall/index';
            if (!hotelId) {
                this.hallList = []
                return false
            }
            post(url, {
                store_id: hotelId
            }).then(function (res) {
                if (res.code == '200')
                    _this.hallList = res.data.list;
                _this.halltitle = res.data.list.title;
            })
        },
        getSchedule() {
            let _this = this;
            let url = '/api/order.schedule/index';
            let query = this.query;
            if (!query.year) {
                this.$message({
                    message: '请选择年份',
                });
                return false
            }
            post(url, query).then(function (res) {
                _this.group = res.data.group
            })
        },
        getBanquetType(e) {
            this.orderParams.banquet_type = e.detail.value;
        },
        //判读闰年
        isLeapYear(e) {
            if (e % 4 == 0 && e % 100 != 0 || e % 400 == 0) {
                this.Feb = 29
            } else {
                this.Feb = 28
            }
        },
        //添加婚礼档期
        openDialog(hallId, year, month, day, type) {
            if (!year) {
                this.$message("请选择年份");
                return false;
            }
            if (this.$refs.addSchedule) {
                this.$refs.addSchedule.showDialog(hallId, year, month, day, type)
            } else {
                this.$nextTick(function () {
                    this.$refs.addSchedule.showDialog(hallId, year, month, day, type)
                })
            }
        },
        //查看婚礼档期详情
        openDetailsDialog(hotelId, year, month, day) {

            if (this.$refs.detailsSchedule) {
                this.$refs.detailsSchedule.showDetailDialog(hotelId, year, month, day)
            } else {
                this.$nextTick(function () {
                    this.$refs.detailsSchedule.showDetailDialog(hotelId, year, month, day)
                })
            }

        }

    }
}
</script>

<style lang="less">
@import url('@/assets/css/common.less');

.tag_list {
    margin-left: 40px;
    width: 124px;
    position: relative;

    .tag_font {
        position: absolute;
        left: 0;
        top: 4px;
    }

    .tag_schedul {
        font-size: 8px;
        width: 60px;
        height: 8px;
        margin-bottom: 3px;
        background-color: blue;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 10px;
    }

    .tag_order {
        font-size: 8px;
        width: 60px;
        height: 8px;
        margin-bottom: 3px;
        background-color: red;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 10px;
    }

    .tag_order_contant {
        font-size: 8px;
        width: 60px;
        height: 8px;
        margin-bottom: 3px;
        background-color: #fdb933;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 10px;
    }

    .tag_order_bb {
        font-size: 8px;
        width: 60px;
        height: 8px;
        margin-bottom: 3px;
        background-color: #5c7a29;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 10px;
    }

    .tag_wanyan {
        font-size: 8px;
        width: 8px;
        height: 8px;
        border-radius: 100%;
        margin-bottom: 3px;
        background-color: #008792;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 10px;
    }

    .tag_wuyan {
        font-size: 8px;
        width: 8px;
        height: 8px;
        border-radius: 100%;
        margin-bottom: 3px;
        background-color: #f15a22;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 10px;
    }
}

.content {
    width: auto;
    height: 100%;
    overflow-y: auto !important;
}

.month-box {
    border-top: 1px solid #dedede;

    .month-header {
        display: flex;
        width: 100%;
        background-color: #e7ecf1;

        .col-day {
            flex: 1;
            padding: 6px 10px;
            border-left: 1px solid #dedede;
        }

        .col-day:last-child {
            border-right: 1px solid #dedede;
        }
    }

    .month-body {
        .row-hall {
            display: flex;
            width: 100%;
            border-top: 1px solid #dedede;

            .col-day {
                flex: 1;
                padding: 6px 4px;
                border-left: 1px solid #dedede;
                text-align: center;

                .tag {
                    font-size: 8px;
                    width: 100%;
                    height: 8px;
                    margin-bottom: 3px;
                }

                .tag-0 {
                    background-color: red; //默认订单
                }

                .tag-schedule {
                    background-color: blue; //添加档期
                }

                .tag-2 {
                    background-color: royalblue; //一站式
                }

                .tag-7 {
                    //宝宝订单
                    background-color: #5c7a29;
                }

                .tag-8 {
                    //会务订单
                    background-color: #fdb933;
                }
            }

            .col-day:last-child {
                border-right: 1px solid #dedede;
            }
        }
    }

    .col-title {
        flex: 0 6rem !important;
        font-weight: 900;
    }
}

.month-box:last-child {
    border-bottom: 1px solid #dedede;
    font-weight: 500;
}

.col_list {
    display: flex;

    .col_item {
        font-size: 12px;
        min-width: 16px;
        height: 8px;

        .banquet_type {
            display: inline-block;
            font-size: 0;
            overflow: hidden;
            vertical-align: 6px;

            .dot_wuyan {
                width: 8px;
                height: 8px;
                border-radius: 100%;
                background: #f15a22;
                display: inline-block;
                margin-top: -6px;
            }

            .dot_wanyan {
                width: 8px;
                height: 8px;
                border-radius: 100%;
                background: #008792;
                display: inline-block;
                margin-top: -6px;
            }
        }
    }
}
</style>
